import actions from "./actions";

import circle2 from "../../assets/images/reservation-tables/circle-2.png";
import circle4 from "../../assets/images/reservation-tables/circle-4.png";
import circle8 from "../../assets/images/reservation-tables/circle-8.png";
import rectangle10 from "../../assets/images/reservation-tables/rectangle-10.png";
import rectangle6 from "../../assets/images/reservation-tables/rectangle-6.png";
import rectangle8 from "../../assets/images/reservation-tables/rectangle-8.png";
import square1 from "../../assets/images/reservation-tables/square-1.png";
import square2 from "../../assets/images/reservation-tables/square-2.png";
import square3 from "../../assets/images/reservation-tables/square-3.png";
import square4 from "../../assets/images/reservation-tables/square-4.png";
import RestaurantSchemeTablesForReservations from "../../components/User/RestaurantSchemeComponent/RestaurantSchemeTablesForReservations";

const initState = {
  tables: [],
  regions: [],
  touchSaleTablesPerRegion: [],
};

const getSrc = (shape, seatsCount) => {
  if (shape === 1) {
    return seatsCount === 2 ? circle2 : seatsCount === 4 ? circle4 : circle8;
  } else if (shape === 2) {
    return seatsCount === 1
      ? square1
      : seatsCount === 2
      ? square2
      : seatsCount === 3
      ? square3
      : square4;
  } else if (shape === 3) {
    return seatsCount === 6
      ? rectangle6
      : seatsCount === 8
      ? rectangle8
      : rectangle10;
  }
};

const getAspectRatio = (shape, seatsCount) => {
  if (shape === 1) {
    return seatsCount === 2 ? "0.76 / 1" : seatsCount === 4 ? "1 / 1" : "1 / 1";
  } else if (shape === 2) {
    return seatsCount === 1
      ? "0.67 / 1"
      : seatsCount === 2
      ? "0.58 / 1"
      : seatsCount === 3
      ? "0.86 / 1"
      : "1 / 1";
  } else if (shape === 3) {
    return seatsCount === 6
      ? "1.35 / 1"
      : seatsCount === 8
      ? "2 / 1"
      : "2.2 / 1";
  }
};

export default function restaurantSchemaReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.CREATE_NEW_RESERVATION_TABLE_SUCCESS:
      action.table.src = getSrc(action.table.shape, action.table.seatsCount);
      action.table.aspectRatio = getAspectRatio(
        action.table.shape,
        action.table.seatsCount
      );
      return {
        ...state,
        tables: [...state.tables, action.table],
      };

    case actions.EDIT_RESERVATION_TABLE_SUCCESS:
      const updatedTables = state.tables.map((table) =>
        table.touchSaleTableId === action.table.touchSaleTableId
          ? {
              ...table,
              x: action.table.x,
              y: action.table.y,
              direction: action.table.direction,
              shape: action.table.shape,
              seatsCount: action.table.seatsCount,
              src: getSrc(action.table.shape, action.table.seatsCount),
              aspectRatio: getAspectRatio(
                action.table.shape,
                action.table.seatsCount
              ),
            }
          : table
      );
      return {
        ...state,
        tables: updatedTables,
      };

    case actions.DELETE_RESERVATION_TABLE_SUCCESS:
      return {
        ...state,
        tables: state.tables.filter(
          (table) => table.touchSaleTableId !== action.table.touchSaleTableId
        ),
      };

    case actions.GET_RESERVATION_TABLE_SUCCESS:
      const tables = action.tables.map((table) => ({
        ...table,
        src: getSrc(table.shape, table.seatsCount),
        aspectRatio: getAspectRatio(table.shape, table.seatsCount),
      }));
      return {
        ...state,
        tables: tables,
      };

    case actions.CREATE_NEW_REGION_SUCCESS:
      const newRegion = {
        label: action.region.name,
        key: action.region.regionId,
        closable: false,
        backgroundImage: action.region.backgroundImage,
        children: (
          <RestaurantSchemeTablesForReservations
            regionId={action.region.regionId}
          />
        ),
      };
      return {
        ...state,
        regions: [...state.regions, newRegion],
      };

    case actions.GET_REGIONS_SUCCESS:
      const regions = action.regions.map((region) => ({
        label: region.name,
        key: region.regionId,
        closable: false,
        backgroundImage: region.backgroundImage,
        children: (
          <RestaurantSchemeTablesForReservations
            regionId={region.regionId}
            backgroundImage={region.backgroundImage}
          />
        ),
      }));

      return {
        ...state,
        regions: regions,
      };

    case actions.EDIT_REGION_SUCCESS:
      const updatedRegions = state.regions.map((region) =>
        region.key === action.region.regionId
          ? {
              ...region,
              label: action.region.name,
            }
          : region
      );

      return {
        ...state,
        regions: updatedRegions,
      };

    case actions.DELETE_REGION_SUCCESS:
      return {
        ...state,
        regions: state.regions.filter(
          (region) => region.key !== action.region.regionId
        ),
      };

    case actions.GET_TOUCHSALE_TABLES_PER_REGION_SUCCESS:
      return {
        ...state,
        touchSaleTablesPerRegion: action.touchsaleTables,
      };

    case actions.BUSY_OR_FREE_TABLE_SUCCESS:
      return {
        ...state,
        tables: state.tables.map((table) =>
          table.touchSaleTableId === action.editTable.touchSaleTableId
            ? { ...table, busy: action.editTable.busy }
            : table
        ),
      };

    default:
      return state;
  }
}
